import React, { memo, useMemo } from "react";
import { useUsers } from "modules/providers/users-provider";
import { getUserFullName } from "modules/utils/Functions";
import { UserRoleType } from "gql/graphql";
import { Text } from "@chakra-ui/react";
import colors from "app/colors";

interface IProps {
  userId: string;
  displayOnlyFirstName?: boolean;
}

const UserName = ({ userId, displayOnlyFirstName = false }: IProps) => {
  const { usersById } = useUsers();
  const user = usersById[userId];
  const name = useMemo(() => {
    if (!user) return;
    const name = displayOnlyFirstName ? user.firstName : getUserFullName(user);
    if (
      (user.roleType === UserRoleType.Email && !name) ||
      name.trim().length === 0
    ) {
      return user.email;
    }
    return name;
  }, [displayOnlyFirstName, user]);
  if (!user) return null;
  if (!name) return null;
  if (!user.active) {
    return (
      <Text color={colors.grayMain} fontStyle="italic" as="span">
        {name}
      </Text>
    );
  }
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <React.Fragment>{name}</React.Fragment>;
};

export default memo(UserName);
